import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { CasinoIcon } from '@swf/casino';
import { CasinoGameIcon } from '@swf/casino';
import type { Dispatch } from '@swf/core/store';
import type { Promo } from '@swf/core/types/CasinoGame';
import { launchGame } from '@swf/core/utils/casino';

import styles from './CasinoPromoTile.scss';

export interface Props
  extends Pick<Parameters<typeof CasinoGameIcon>['0'], 'icon' | 'className' | 'mosaicHint'> {
  icon: CasinoIcon;
  index: number;
  promo: Promo;
}

const CasinoPromoTile: React.FC<Props> = ({ icon = 'icnSquare', className, mosaicHint, promo }) => {
  const { url = '', path = '', title = '' } = promo;
  const { modal } = useDispatch<Dispatch>();

  switch (promo.type) {
    case 'promo-game':
      return (
        <CasinoGameIcon
          className={classNames(styles.container, className)}
          onClick={() => launchGame({ code: `${promo.game?.gametype}-${promo.game?.variant}` })}
          icon={icon}
          mosaicHint={mosaicHint}
          images={promo.images}
        />
      );
    case 'promo-modal':
      return (
        <CasinoGameIcon
          className={classNames(styles.container, className)}
          icon={icon}
          mosaicHint={mosaicHint}
          images={promo.images}
          onClick={() => {
            modal.close(path);
            modal.enqueue({ path, locationState: { title } });
          }}
        />
      );
    case 'promo-tab':
      return (
        <CasinoGameIcon
          className={classNames(styles.container, className)}
          icon={icon}
          mosaicHint={mosaicHint}
          images={promo.images}
          onClick={() => window.open(url, '_blank')?.focus()}
        />
      );
    case 'promo-frame':
      return (
        <CasinoGameIcon
          className={classNames(styles.container, styles.frame, className)}
          icon={icon}
          mosaicHint={mosaicHint}
          images={promo.images}
          onClick={() => window.open(url, '_blank')?.focus()}
        >
          <iframe title="externalTest" src={url} frameBorder="0" scrolling="yes" />
        </CasinoGameIcon>
      );
  }
  return null;
};

export default CasinoPromoTile;
